import React, { Component } from 'react'
import CatalogSvg from '../components/svg/CatalogSvg'
import EuroColdListSection from '../components/EuroColdListSection';
import { connect } from 'react-redux';
import { getEurocoldProduct } from '../actions/MainAction';
import Card14 from '../components/cards/Card14';

export class EuroCold extends Component {
    state = {
        menuVisible: false,
        filteredProducts: [],
        selectedSubCategoryId: null,
        screenWidth: window.innerWidth,
    };

    toggleMenu = () => {
        this.setState((prevState) => ({
            menuVisible: !prevState.menuVisible,
        }));
    };

    componentDidMount() {
        this.props.getEurocoldProduct();
        window.addEventListener('resize', this.updateScreenWidth);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateScreenWidth);
    }

    updateScreenWidth = () => {
        this.setState({ screenWidth: window.innerWidth });
    };


    componentDidUpdate(prevProps) {
        if (prevProps.eurocoldProductData !== this.props.eurocoldProductData) {
            this.setState({ filteredProducts: this.props.eurocoldProductData });
        }
    }

    handleSubCategorySelect = async (subId) => {
        const { eurocoldProductData } = this.props;

        if (subId) {
            const filtered = eurocoldProductData.filter((item) =>
                Number(item?.euro_cold_sub_catagories) === Number(subId)
            );

            this.setState({ filteredProducts: filtered });
        } else {
            this.setState({ filteredProducts: eurocoldProductData });
        }

        this.setState({ selectedSubCategoryId: subId });
    };


    render() {
        const { menuVisible, filteredProducts, screenWidth } = this.state;

        return (
            <main>
                <section className='container flex w-full'>
                    <div className='rounded-[12px] hidden max-[1024px]:inline-block'>
                        <label
                            id='kataloq'
                            className='flex items-center gap-[6px]'
                            onClick={this.toggleMenu}
                        >
                            <CatalogSvg />
                            <span className='font-[500] text-[18px] text-[#00]'>Kataloq</span>
                        </label>
                    </div>
                </section>

                <section className='flex items-start h-full gap-[32px] container pt-[32px]'>
                    <div className='h-[full]'>
                        {menuVisible && screenWidth <= 1024 && (
                            <div className={`product-list-wrapper listclass ${menuVisible ? 'visible' : ''} ${menuVisible && screenWidth <= 1024 ? 'full-screen' : ''}`}>
                                <EuroColdListSection onSubCategorySelect={this.handleSubCategorySelect} closeMenu={this.toggleMenu} />
                            </div>
                        )}

                        {screenWidth > 1024 && (
                            <div className='product-list-wrapper listclass '>
                                <EuroColdListSection onSubCategorySelect={this.handleSubCategorySelect} closeMenu={this.toggleMenu} />
                            </div>
                        )}
                    </div>
                    <div className='h-full'>

                    </div>

                    <div className='flex flex-col w-full'>
                        <div className='mt-[-10px] mb-[20px]'>
                            <div className='flex justify-start w-full gap-[8px]'>
                                <h2 className='font-[500] text-[40px] text-center text-[#030303] max-[550px]:text-[30px] max-[400px]:text-[26px]'>
                                    Məhsullar
                                </h2>
                            </div>
                        </div>

                        <div className='w-full grid grid-cols-3 gap-[32px] max-[1024px]:gap-[20px] max-[1024px]:grid-cols-4 max-[768px]:grid-cols-3 max-[580px]:grid-cols-2 max-[370px]:grid-cols-1'>
                            {filteredProducts?.map((data, i) => (
                                <Card14
                                    key={i}
                                    image_full_url={data?.image_full_url}
                                    description={data?.description}
                                    title={data?.title}
                                    id={data?.id}
                                    price={data?.price}
                                />
                            ))}
                        </div>
                    </div>
                </section>
            </main>
        );
    }
}

const mapStateProps = (state) => ({
    eurocoldProductData: state.Data.eurocoldProductData,
});

const mapDispatchToProps = { getEurocoldProduct };

export default connect(mapStateProps, mapDispatchToProps)(EuroCold);
